import { render, staticRenderFns } from "./image_list.vue?vue&type=template&id=2122fa41&scoped=true&"
import script from "./image_list.vue?vue&type=script&lang=js&"
export * from "./image_list.vue?vue&type=script&lang=js&"
import style0 from "./image_list.vue?vue&type=style&index=0&id=2122fa41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122fa41",
  null
  
)

export default component.exports